import { generateId } from '@freelancer/datastore/testing';
import {
  ContextTypeApi,
  ThreadTypeApi,
} from 'api-typings/messages/messages_types';
import { CommentFeed } from './comment-feeds.model';

export interface GenerateCommentFeedOptions {
  readonly contextId: number;
}

export function generateCommentFeedObject({
  contextId,
}: GenerateCommentFeedOptions): CommentFeed {
  const now = Date.now();
  return {
    id: generateId(),
    contextType: ContextTypeApi.POST,
    contextId,
    members: [],
    owner: 0,
    threadType: ThreadTypeApi.COMMENT_FEED,
    timeCreated: now,
    timeUpdated: now,
    timeRead: now,
  };
}
